<button class="btn btn-lg btn-primary btn-block mt-2 text-white" (click)="redirectToShibboleth()">
  <i class="fas fa-sign-in-alt"></i> {{"login.form.shibboleth" | translate}}
</button>
